<template>
  <div
    class="right-rollout fixed right-0 top-0 bottom-0 w-[400px] bg-white border-l border-gray-200 shadow-lg z-40 transition-transform duration-250 overflow-y-auto"
    :class="store.rightRolloutOpen.value ? 'translate-x-0' : 'translate-x-full'"
  >
    <div class="p-4">
      <div class="flex items-center justify-between mb-4">
        <h3 class="font-medium text-gray-900">
          {{ store.rightRolloutMode.value === 'author-edit' ? 'Edit Author' : 'Version Diff' }}
        </h3>
        <button
          @click="store.rightRolloutOpen.value = false"
          class="text-gray-500 hover:text-gray-700 text-lg"
        >&times;</button>
      </div>

      <template v-if="store.rightRolloutMode.value === 'author-edit' && store.currentAuthor.value">
        <div class="space-y-3 text-sm">
          <div>
            <label class="text-sm font-medium text-gray-800">Name</label>
            <p class="text-gray-900">{{ store.currentAuthor.value.name }}</p>
          </div>
          <div>
            <label class="text-sm font-medium text-gray-800">Bio</label>
            <p class="text-gray-700">{{ store.currentAuthor.value.bio || 'Not set' }}</p>
          </div>
          <div v-if="store.currentAuthor.value.author_examples?.length">
            <label class="text-sm font-medium text-gray-800">Examples</label>
            <div v-for="ex in store.currentAuthor.value.author_examples" :key="ex.id" class="mt-1 bg-gray-50 rounded p-2">
              <p class="text-sm text-gray-700 mt-0.5 line-clamp-3">{{ ex.content }}</p>
            </div>
          </div>
        </div>
      </template>

      <template v-if="store.rightRolloutMode.value === 'version-diff'">
        <p class="text-sm text-gray-600 italic">Version comparison coming soon.</p>
      </template>
    </div>
  </div>
</template>

<script setup>
import { inject } from 'vue'
const store = inject('workbench')
</script>
